module.exports = __webpack_public_path__ + "static/media/animals.d69c0cff.svg";